'use client';

import { motion } from 'framer-motion';
import {
  BASE_FADEIN_DURATION,
  BASE_Y,
  DEFAULT_DELAY,
  getFadeInAndUpProps,
} from 'app/(user)/_utils/shared-animations';
import { Text } from '@/components/Text/Text';
import type { HomePage } from '@/sanity/schemas/home-page/types';
import styles from './homepage-header.module.css';
import { SanityImage } from '@/components/SanityImage';
import { VaporDropHalo } from '../VaporDropHalo';

type Props = Pick<HomePage, 'title' | 'description' | 'image'>;

export function HomePageHeader({ title, description, image }: Props) {
  const startingY = BASE_Y * -4;

  return (
    <>
      <motion.div
        className={styles.vaporDropHaloContainer}
        {...getFadeInAndUpProps({
          startingY,
          duration: BASE_FADEIN_DURATION * 3,
        })}
      >
        <VaporDropHalo />
      </motion.div>
      <div className={styles.header}>
        <motion.div
          {...getFadeInAndUpProps({
            startingY,
            duration: BASE_FADEIN_DURATION * 3,
          })}
        >
          <SanityImage
            src={image}
            width={117}
            height={138}
            alt=""
            aria-hidden={true}
          />
        </motion.div>
        <motion.div
          className={styles.title}
          {...getFadeInAndUpProps({
            startingY,
            duration: BASE_FADEIN_DURATION * 3,
            delay: DEFAULT_DELAY,
          })}
        >
          <Text color="primary" variant="displayXL">
            {title}
          </Text>
        </motion.div>
        <motion.div
          className={styles.description}
          {...getFadeInAndUpProps({
            startingY,
            duration: BASE_FADEIN_DURATION * 3,
            delay: DEFAULT_DELAY * 2,
          })}
        >
          <Text color="tertiary" variant="subtitle1">
            {description}
          </Text>
        </motion.div>
      </div>
    </>
  );
}
